import { useSelector } from 'react-redux';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const SecureFilesDefaultWidget = (props) => {
  const global = useSelector((state) => state.global);
  return (
    <DefaultWidgetTemplate
      module={props.module}
      oldRoute={`${global?.urlData?.rootProject}secure-files/${props.module[props.module.name].slug}/`}
    />
  );
};

export default SecureFilesDefaultWidget;
